/* ============================================================
   Veridia Shop — shared product grid + filters engine
   Reads config from window.veridiaShopConfig
   Uses event delegation (no inline handlers) for reliability.
   ============================================================ */
(function () {
  function init() {
    var cfg = window.veridiaShopConfig || {};
    var mode = cfg.mode || 'collection';
    var endpoint = cfg.endpoint || '/collections/all/products.json';
    var limit = cfg.limit || 200;
    var defaultSort = cfg.defaultSort || 'created-descending';
    var maxDaysOld = cfg.maxDaysOld || null;
    var maxProducts = cfg.maxProducts || null;
    var moneyDecimals = (typeof cfg.moneyDecimals === 'number') ? cfg.moneyDecimals : 2;

    var gridEl = document.getElementById('vs-grid');
    var skeletonEl = document.getElementById('vs-skeleton');
    var emptyEl = document.getElementById('vs-empty');
    var emptyTitleEl = emptyEl ? emptyEl.querySelector('h2') : null;
    var emptyTextEl = emptyEl ? emptyEl.querySelector('p') : null;
    var totalEl = document.getElementById('vs-total');
    var totalLabelEl = document.getElementById('vs-total-label');
    var sortEl = document.getElementById('vs-sort');
    var panelEl = document.getElementById('vs-filters-panel');
    var toggleBtn = document.getElementById('vs-filter-toggle');
    var clearBtn = document.getElementById('vs-filter-clear');

    if (!gridEl) { return; }

    var allProducts = [];
    var filteredProducts = [];
    var activeFilters = { inStock: null };
    var activeType = null;
    var currentSort = defaultSort;

    try {
      activeType = new URLSearchParams(window.location.search).get('filter.p.product_type');
    } catch (e) { activeType = null; }

    function fetchProducts() {
      skeletonEl.style.display = 'grid';
      gridEl.style.display = 'none';
      emptyEl.style.display = 'none';

      var sep = endpoint.indexOf('?') === -1 ? '?' : '&';
      var url = endpoint + sep + 'limit=' + limit;

      fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data && data.products) ? data.products : [];

          if (maxDaysOld) {
            var cutoff = new Date();
            cutoff.setDate(cutoff.getDate() - maxDaysOld);
            products = products.filter(function (p) {
              return new Date(p.created_at) >= cutoff;
            });
          }
          if (maxProducts) {
            products = products.slice(0, maxProducts);
          }

          allProducts = products;
          renderProducts();
          skeletonEl.style.display = 'none';
        })
        .catch(function () {
          skeletonEl.style.display = 'none';
          gridEl.style.display = 'none';
          emptyEl.style.display = 'block';
        });
    }

    function applyFilters() {
      var inStockEl = panelEl.querySelector('input[value="in-stock"]');
      var oosEl = panelEl.querySelector('input[value="out-of-stock"]');
      var inStock = inStockEl ? inStockEl.checked : false;
      var outOfStock = oosEl ? oosEl.checked : false;
      if (inStock && !outOfStock) activeFilters.inStock = true;
      else if (!inStock && outOfStock) activeFilters.inStock = false;
      else activeFilters.inStock = null;

      renderProducts();
    }

    function clearFilters() {
      panelEl.querySelectorAll('input[type="checkbox"]').forEach(function (c) { c.checked = false; });
      activeFilters = { inStock: null };
      renderProducts();
    }

    function variantPrice(p) {
      return p.variants && p.variants[0] ? parseFloat(p.variants[0].price) : 0;
    }

    function sortProducts(list) {
      var arr = list.slice();
      switch (currentSort) {
        case 'price-ascending':
          arr.sort(function (a, b) { return variantPrice(a) - variantPrice(b); });
          break;
        case 'price-descending':
          arr.sort(function (a, b) { return variantPrice(b) - variantPrice(a); });
          break;
        case 'title-ascending':
          arr.sort(function (a, b) { return (a.title || '').localeCompare(b.title || ''); });
          break;
        case 'title-descending':
          arr.sort(function (a, b) { return (b.title || '').localeCompare(a.title || ''); });
          break;
        case 'created-ascending':
          arr.sort(function (a, b) { return new Date(a.created_at) - new Date(b.created_at); });
          break;
        case 'created-descending':
          arr.sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); });
          break;
        default:
          /* best-selling / manual: keep original order from the API */
          break;
      }
      return arr;
    }

    function renderProducts() {
      filteredProducts = sortProducts(allProducts);

      if (activeType) {
        filteredProducts = filteredProducts.filter(function (p) {
          return (p.product_type || '') === activeType;
        });
      }
      if (activeFilters.inStock === true) {
        filteredProducts = filteredProducts.filter(function (p) { return p.variants[0] && p.variants[0].available; });
      } else if (activeFilters.inStock === false) {
        filteredProducts = filteredProducts.filter(function (p) { return !p.variants[0] || !p.variants[0].available; });
      }

      if (filteredProducts.length === 0) {
        gridEl.style.display = 'none';
        emptyEl.style.display = 'block';
        if (totalEl) totalEl.textContent = '0';
        if (totalLabelEl) totalLabelEl.textContent = 'Product';
        if (allProducts.length > 0) {
          if (emptyTitleEl) emptyTitleEl.textContent = 'No products match your selection';
          if (emptyTextEl) emptyTextEl.textContent = 'Try adjusting your filters or browse our full collection.';
        } else {
          if (emptyTitleEl) emptyTitleEl.textContent = emptyTitleEl.getAttribute('data-default') || 'Coming soon';
          if (emptyTextEl) emptyTextEl.textContent = emptyTextEl.getAttribute('data-default') || 'We\'re curating pieces for this category. Browse our full collection in the meantime.';
        }
        return;
      }

      emptyEl.style.display = 'none';
      if (emptyTitleEl) emptyTitleEl.textContent = emptyTitleEl.getAttribute('data-default') || 'Coming soon';
      if (emptyTextEl) emptyTextEl.textContent = emptyTextEl.getAttribute('data-default') || 'We\'re curating pieces for this category. Browse our full collection in the meantime.';
      gridEl.style.display = 'grid';
      if (totalEl) totalEl.textContent = filteredProducts.length;
      if (totalLabelEl) totalLabelEl.textContent = filteredProducts.length <= 1 ? 'Product' : 'Products';

      var html = '';
      filteredProducts.forEach(function (p, i) { html += renderCard(p, i); });
      gridEl.innerHTML = html;
    }

    function renderCard(p, idx) {
      var v = p.variants && p.variants[0] ? p.variants[0] : null;
      var price = v ? parseFloat(v.price) : 0;
      var compareAt = v && v.compare_at_price ? parseFloat(v.compare_at_price) : 0;
      var discount = compareAt > price ? Math.round((compareAt - price) / compareAt * 100) : 0;
      var catName = p.product_type || 'General';
      var imgUrl = p.images && p.images.length > 0 ? p.images[0].src : '';
      var variantId = v ? v.id : 0;

      var badgesHtml = '';
      if (mode === 'best-sellers') {
        badgesHtml += '<span class="badge-bestseller">Best Seller</span>';
      } else {
        var days = Math.floor((Date.now() - new Date(p.created_at).getTime()) / 86400000);
        if (days <= 30) badgesHtml += '<span class="badge-new">New</span>';
      }
      if (discount > 0) badgesHtml += '<span class="badge-discount">&minus;' + discount + '%</span>';
      badgesHtml += '<span class="badge-category">' + escapeHtml(catName) + '</span>';

      var starsHtml = '';
      for (var s = 1; s <= 5; s++) {
        var col = s <= 4 ? 'var(--gold)' : 'rgba(44,44,44,0.2)';
        starsHtml += '<svg viewBox="0 0 24 24" fill="' + col + '" stroke="' + col + '" stroke-width="1.2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
      }

      var priceHtml = '<div class="product-card-price-current">' + formatMoney(price) + '</div>';
      if (discount > 0) priceHtml += '<div class="product-card-price-compare">' + formatMoney(compareAt) + '</div>';

      return '<article class="product-card-item" data-index="' + idx + '">'
        + '<a href="/products/' + p.handle + '">'
        + '<div class="product-card-image-wrap">'
        + '<img src="' + imgUrl + '" alt="' + escapeAttr(p.title) + '" loading="lazy" width="600" height="750">'
        + '<div class="product-card-badges">' + badgesHtml + '</div>'
        + '<div class="product-card-hover">'
        + '<button type="button" class="vs-add" data-variant="' + variantId + '">Add to bag</button>'
        + '</div>'
        + '</div>'
        + '<div class="product-card-info">'
        + '<div class="product-card-info-left">'
        + '<div class="product-card-category">' + escapeHtml(catName) + '</div>'
        + '<h3 class="product-card-title">' + escapeHtml(p.title) + '</h3>'
        + '<div style="display:flex;align-items:center;margin-top:6px"><div class="product-card-rating">' + starsHtml + '</div></div>'
        + '</div>'
        + '<div class="product-card-price">' + priceHtml + '</div>'
        + '</div>'
        + '</a>'
        + '<button type="button" class="product-card-wishlist vs-wishlist" data-handle="' + escapeAttr(p.handle) + '" aria-label="Add to wishlist">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" style="color:var(--charcoal)"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>'
        + '</button>'
        + '</article>';
    }

    function formatMoney(amount) {
      try {
        return '\u20B9' + amount.toLocaleString('en-IN', {
          minimumFractionDigits: moneyDecimals,
          maximumFractionDigits: moneyDecimals
        });
      } catch (e) {
        return '\u20B9' + amount.toFixed(moneyDecimals);
      }
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str == null ? '' : String(str);
      return div.innerHTML;
    }
    function escapeAttr(str) {
      return escapeHtml(str).replace(/"/g, '&quot;');
    }

    function addToCart(variantId) {
      if (!variantId) return;
      if (typeof window.addToCart === 'function' && window.addToCart !== addToCart) {
        window.addToCart(variantId, 1);
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function () {
          if (window.updateCartCount) window.updateCartCount();
        })
        .catch(function (e) { console.error('Cart error:', e); });
    }

    /* ---------- Event wiring (delegation) ---------- */
    if (sortEl) {
      sortEl.value = currentSort;
      sortEl.addEventListener('change', function () {
        currentSort = this.value;
        renderProducts();
      });
    }
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () { panelEl.classList.toggle('open'); });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', clearFilters);
    }
    if (panelEl) {
      panelEl.addEventListener('change', function (e) {
        if (e.target && e.target.matches('input[type="checkbox"]')) { applyFilters(); }
      });
    }
    gridEl.addEventListener('click', function (e) {
      var addBtn = e.target.closest('.vs-add');
      if (addBtn) {
        e.preventDefault();
        addToCart(parseInt(addBtn.getAttribute('data-variant'), 10));
        return;
      }
      var wish = e.target.closest('.vs-wishlist');
      if (wish) {
        e.preventDefault();
        var svg = wish.querySelector('svg');
        svg.style.fill = svg.style.fill === 'var(--charcoal)' ? 'none' : 'var(--charcoal)';
      }
    });

    fetchProducts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
